import { Button } from "primereact/button";

interface FormStepFooterProps {
    activeStep: number;
    isLastStep: boolean;
    isSkipping: boolean;
    isNextDisabled: boolean;
    canSubmit: boolean;
    onPrevious: () => void;
    onNext: () => void;
    labels: {
        back: string;
        next: string;
        skip: string;
        create: string;
    };
    form_name: string;
}

export const FormStepFooter = ({
    activeStep,
    isLastStep,
    isSkipping,
    isNextDisabled,
    canSubmit,
    onPrevious,
    onNext,
    labels,
    form_name
}: FormStepFooterProps) => (
    <div className="flex align-items-center justify-content-between pt-2">
        {activeStep !== 0 ? (
            <Button
                label={labels.back}
                icon="pi pi-arrow-left"
                severity="secondary"
                outlined
                onClick={onPrevious}
                type="button"
            />
        ) : (
            <span />
        )}
        {isLastStep ? (
            <Button
                key="create-button"
                id="button-create"
                icon="pi pi-plus-circle"
                label={labels.create}
                className="p-button-raised"
                type="submit"
                form={form_name}
                disabled={!canSubmit}
            />
        ) : (
            <Button
                key="next-button"
                label={isSkipping ? labels.skip : labels.next}
                icon={isSkipping ? 'pi pi-forward' : 'pi pi-arrow-right'}
                iconPos="right"
                onClick={onNext}
                type="button"
                disabled={isNextDisabled}
                severity={isSkipping ? 'secondary' : undefined}
                outlined={isSkipping}
            />
        )}
    </div>
);